import type { CandidateReview } from "../api/review";

/** Where this candidate got to, step by step. Shown for every application. */
export function CandidateFunnel({ review }: { review: CandidateReview }) {
  return (
    <section id="progress" aria-label="Progress">
      <h2>Progress</h2>
      <ol className="checklist">
        {review.funnel.map((s) => (
          <li key={s.step} className={s.reached ? "done" : "todo"}>
            {s.label}
            {s.step === "agent_connected" && s.reached && review.agent_via && (
              <span className="muted"> · via {review.agent_via}</span>
            )}
            <span className="muted">
              {s.reached
                ? s.at
                  ? ` · ${new Date(s.at).toLocaleString()}`
                  : " · time not recorded"
                : ""}
            </span>
            <span className="visually-hidden">{s.reached ? " (done)" : " (not yet)"}</span>
          </li>
        ))}
      </ol>
    </section>
  );
}
